import { useTheme } from '@mui/material';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

interface CheckCircleFilledIconProps extends SvgIconProps {
    checkColor?: string;
    checkColorOpacity?: string;
    fill?: string;
}

const CheckCircleFilledIcon = (props: CheckCircleFilledIconProps) => {
    const theme = useTheme();

    return (
        <SvgIcon viewBox="0 0 25 25" {...props}>
            <path
                opacity={props.checkColorOpacity || '1'}
                fill={props.fill || theme.palette.primary.main}
                d="M19.0709 19.0709C15.1655 22.9764 8.83453 22.9764 4.92909 19.0709C1.02364 15.1655 1.02364 8.83453 4.92909 4.92908C8.83453 1.02363 15.1655 1.02363 19.0709 4.92908C22.9764 8.83453 22.9764 15.1655 19.0709 19.0709Z"
            />
            <path
                d="M16.5635 8.17385C16.8817 8.43902 16.9247 8.91195 16.6595 9.23016L11.6597 15.23C11.5248 15.3919 11.328 15.4896 11.1175 15.4991C10.907 15.5086 10.7022 15.4292 10.5532 15.2802L7.55304 12.28C7.26015 11.9872 7.26015 11.5123 7.55304 11.2194C7.84594 10.9265 8.32081 10.9265 8.6137 11.2194L11.0331 13.6388L15.5072 8.26988C15.7724 7.95167 16.2453 7.90868 16.5635 8.17385Z"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
                fill={props.checkColor || theme.palette.common.white}
            />
        </SvgIcon>
    );
};

export default CheckCircleFilledIcon;
